module.exports = __webpack_public_path__ + "img/active-second.2d9f6f06.png";